module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Central.b623196b.webp";